import styled from 'styled-components';
function Buttons() {
  return (
    <Wrap>
      <div>
        <ButtonFirst type="button">
          <a
            href="https://m.expert.naver.com/expert/profile/home?storeId=100001175"
            target="_blank"
            title="Naver Expert"
          >
            변호사 1:1 상담 요청
          </a>
        </ButtonFirst>
      </div>
      <ButtonWrap>
        <Button imgSrc="/images/blog_icon.png" type="button">
          <a
            href="https://m.blog.naver.com/hoonoffice"
            target="_blank"
            title="Naver Expert"
          >
            Blog
          </a>
        </Button>
        <Button imgSrc="/images/phone.svg" type="button">
          <a href="tel:02-733-7112">사무실 전화</a>
        </Button>
      </ButtonWrap>
    </Wrap>
  );
}
const ButtonFirst = styled.button`
  width: 100%;
  color: #ffffff;
  background: ${props => props.theme.mainColor};
  padding: 20px 10px;
  margin-top: 40px;
  font-size: 20px;
  border-radius: 5px;
  background-color: #4a65f4;
  transition: 0.3s ease-out;
  box-shadow: 0px 7px 15px rgba(0, 0, 0, 0.5);
  &:hover {
    background-color: #22319c;
  }
  a {
    display: block;
  }
`;
const Button = styled.button`
  padding: 20px 10px;
  background: #ddae6c no-repeat;
  width: 48%;
  color: #ffffff;
  font-size: 20px;
  border-radius: 5px;
  background-image: url(${props => props.imgSrc});
  background-size: 25px;
  background-position: 20% 50%;
  transition: 0.3s ease-out;
  box-shadow: 0px 7px 15px rgba(0, 0, 0, 0.5);
  &:hover {
    background: #d69f51 no-repeat;
    background-image: url(${props => props.imgSrc});
    background-size: 25px;
    background-position: 20% 50%;
  }
  a {
    display: block;
  }
  @media only screen and (max-width: 992px) {
    background-size: 20px;
    background-position: 15% 50%;
    &:hover {
      background-size: 20px;
      background-position: 15% 50%;
    }
    a {
      font-size: 16px;
    }
  }
`;
const ButtonWrap = styled.p`
  display: flex;
  justify-content: space-between;
  margin: 30px auto;
  width: 50%;
  @media only screen and (max-width: 992px) {
    width: 90%;
  }
`;
const Wrap = styled.div`
  padding: 50px 0;
  div {
    margin: 0 auto;
    width: 50%;
    @media only screen and (max-width: 992px) {
      width: 90%;
    }
  }
  @media only screen and (max-width: 992px) {
    padding: 0px 0;
  }
`;
export default Buttons;
